import RequestBuilder from '../Lib/Requests';

export default class DM1Service {
  api = new RequestBuilder();

  buildDM1FaultsRequest(params, cancelToken) {
    return {
      service: 'rules',
      endpoint: `/v1/dm-alerts`,
      method: 'get',
      params,
      cancelToken,
    };
  }

  getDM1Faults = async (params, cancelToken) => {
    const { data = {} } = await this.api.request(
      this.buildDM1FaultsRequest(params, cancelToken)
    );
    return data;
  };

  buildDM1FiltersRequest(params, cancelToken) {
    return {
      service: 'rules',
      endpoint: `/v1/dm-alert-filters`,
      method: 'get',
      params,
      cancelToken,
    };
  }

  getDM1Filters = async (params, cancelToken) => {
    const { data = {} } = await this.api.request(
      this.buildDM1FiltersRequest(params, cancelToken)
    );
    return data;
  };

  buildDM1FaultsCountRequest(params, cancelToken) {
    return {
      service: 'rules',
      endpoint: `/v1/metrics/dm-alerts`,
      method: 'get',
      params,
      cancelToken,
    };
  }

  getDM1FaultsCount = async (params, cancelToken) => {
    const { data = {} } = await this.api.request(
      this.buildDM1FaultsCountRequest(params, cancelToken)
    );
    return data;
  };

  buildFetchDm1SnapshotsCsvRequest(gatewayID, dm1ID, cancelToken) {
    return {
      cancelToken,
      endpoint: `/gateway/${gatewayID}/snapshot/${dm1ID}`,
      method: 'get',
      service: 'gateway',
    };
  }
  async fetchDm1SnapshotsCsv(gatewayID, dm1ID, cancelToken) {
    const { data = {} } = await this.api.request(
      this.buildFetchDm1SnapshotsCsvRequest(gatewayID, dm1ID, cancelToken)
    );
    return data;
  }
}
